import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import useRosterStore from '../store'
import dayjs from 'dayjs'

export default async function loader({ request: { url } }) {
  const { start, end } = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in Publish Roster loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Publish Roster loader')

  const startDateTime = dayjs(start)
  const endDateTime = dayjs(end)

  const getSourceRosteredShifts = useRosterStore
    .getState()
    .getRosteredShitsByDateRange(startDateTime, endDateTime, 'source')

  //We don't need to add 1 day to the end of the week because the end query param
  //is the next day after the last day of the actual week with the day start preference
  const getDestinationRosteredShifts = useRosterStore
    .getState()
    .getRosteredShitsByDateRange(
      startDateTime.add(1, 'week'),
      endDateTime.add(1, 'week'),
      'destination'
    )

  const getRosterTemplates = useRosterStore.getState().getRosterTemplates(false)

  return defer({
    data: Promise.all([
      getSourceRosteredShifts,
      getDestinationRosteredShifts,
      getRosterTemplates,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Copy Roster Promise.all error', error)
        return false
      }),
  })
}
